import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { mapLanguageToComponentProps } from 'interview/i18n'
import { Flex } from 'components/styled/containers/flex'
import { Body } from 'components/styled/typography'
import { Button } from 'components/styled/button'
import { Confirmation } from 'components/styled/modal/confirmation'
import { StyledTimerText, StyledTimerTextContainer } from '../submit-timer'
import styled from 'styled-components'

const propTypes = {
  i18n: PropTypes.shape({
    sequencedInterview: PropTypes.shape({
      questionAnswerView: PropTypes.shape({
        takesLeft: PropTypes.string,
        retake: PropTypes.string,
        take: PropTypes.string,
        retakeConfirmTitle: PropTypes.string,
        retakeConfirmSubmit: PropTypes.string,
        submitInfoForward: PropTypes.string,
        submitInfoForward2: PropTypes.string,
      }).isRequired,
    }),
  }).isRequired,
  streaming: PropTypes.bool.isRequired,
  recording: PropTypes.bool.isRequired,
  answerSaved: PropTypes.bool.isRequired,
  reconnecting: PropTypes.bool.isRequired,
  interviewState: PropTypes.shape({
    currentQuestion: PropTypes.shape({
      takeLimit: PropTypes.number,
    }),
    onAnswer: PropTypes.bool.isRequired,
    takeCount: PropTypes.number.isRequired,
    stopped: PropTypes.bool.isRequired,
    timeLeftTilNextQuestion: PropTypes.number.isRequired,
  }).isRequired,
  onRetake: PropTypes.func.isRequired,
  candidate: PropTypes.shape({
    _id: PropTypes.string,
    uuid: PropTypes.string,
    opening: PropTypes.shape({
      company: PropTypes.shape({
        _id: PropTypes.string,
        name: PropTypes.string,
      }),
    }),
  }).isRequired,
}

const mapStateToProps = state => ({
  streaming: state.global.opentok.streaming,
  recording: state.global.opentok.recording,
  answerSaved: state.interview.candidate.answerSaved,
  reconnecting: state.global.opentok.reconnecting,
  onAnswer: state.interview.sequencedInterview.interviewState.onAnswer,
  interviewState: state.interview.sequencedInterview.interviewState,
  candidate: state.candidate,
})

const RetakesWrapper = styled(Flex)`
  width: 100%;
`

const StyledRetakesContainer = styled(Flex)`
  justify-content: space-between;
  width: 100%;
  align-items: center;

  ${({ theme }) => theme.mediaQuery.phone} {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${({ theme }) => theme.space.s12};
  }
`

export function Retakes({
  i18n,
  recording,
  onRetake,
  streaming,
  reconnecting,
  answerSaved,
  interviewState,
  candidate,
}) {
  const [showRetakeConfirm, setShowRetakeConfirm] = useState(false)
  const [loadingRetake, setLoadingRetake] = useState(false)

  const { currentQuestion, stopped, takeCount, timeLeftTilNextQuestion } =
    interviewState
  const submitted = answerSaved && !recording
  const languageKeys = i18n.sequencedInterview.questionAnswerView
  const takeLimit = (currentQuestion && currentQuestion.takeLimit) || 1
  const takesLeft = currentQuestion && takeLimit - takeCount

  if (streaming) {
    const renderRetakeButton = !!(stopped && takesLeft && takesLeft > 0)

    const company = candidate && candidate.opening && candidate.opening.company
    const companyData = company && {
      companyId: company._id,
      companyName: company.name,
    }

    const confirmBody = (
      <StyledTimerTextContainer mt="s30" color="grey90">
        {i18n.sequencedInterview.questionAnswerView.submitInfoForward}
        <StyledTimerText color="grey90">
          {timeLeftTilNextQuestion}
        </StyledTimerText>
        {i18n.sequencedInterview.questionAnswerView.submitInfoForward2}
      </StyledTimerTextContainer>
    )

    const retake = () => {
      setLoadingRetake(true)
      Promise.resolve(onRetake()).then(() => {
        setLoadingRetake(false)
      })
    }


    return (
      <>
        <RetakesWrapper
          style={{ width: '100%' }}
          mt="s20"
          justifyContent="space-between"
          alignItems="center"
        >
          <StyledRetakesContainer>
            {!reconnecting && !submitted && (
              <Body className="take-count">
                {`${languageKeys.take} ${takeCount}/${takeLimit}`}
              </Body>
            )}
            {renderRetakeButton && (
              <Button
                variant="secondary"
                onClick={() => setShowRetakeConfirm(true)}
                icon="undo"
                text={languageKeys.retake}
                event={{
                  locationId: 'timedInterviewPage',
                  id: 'retakeButton',
                  properties: {
                    candidateId: candidate._id,
                    ...companyData,
                  },
                }}
              />
            )}
          </StyledRetakesContainer>
          <Confirmation
            size="medium"
            id="retakeConfirmation"
            isOpen={showRetakeConfirm}
            isLoading={loadingRetake}
            title={
              i18n.sequencedInterview.questionAnswerView.retakeConfirmTitle
            }
            onConfirm={() => retake()}
            body={confirmBody}
            closeOnPrimaryClick
            primaryButtonText={
              i18n.sequencedInterview.questionAnswerView.retakeConfirmSubmit
            }
            onCancel={() => setShowRetakeConfirm(false)}
          />
        </RetakesWrapper>
      </>
    )
  }
  return null
}

Retakes.propTypes = propTypes

export default connect(mapLanguageToComponentProps(mapStateToProps))(Retakes)
